export default "__VITE_ASSET__DWjq2cnQ__"